<template>
    <v-dialog v-model="dialog" max-width="500px" persistent>
        <v-card>
          <v-card-title>
            <span class="headline">New Vehicle</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-form ref="newVehicle" v-model="newVehicleValid">
                    <v-text-field 
                        label="Vehicle Registration" 
                        v-model="editedItem.VehicleReg"
                        :rules="[v => !!v || 'Vehicle Registration is required']" 
                        required>
                    </v-text-field>
                    <v-combobox
                        label="Make"
                        v-model="makeSelect"
                        :items="vehicleMakes"
                        item-text="name"
                        item-value="key"
                        clearable></v-combobox>
                    <v-combobox
                        label="Model"
                        v-model="editedItem.Model"
                        :items="modelList"
                        item-text="name"
                        item-value="key"
                        :loading="gettingModels"
                        clearable></v-combobox>
                    <v-text-field
                        label="Year"
                        v-model="editedItem.Year"
                        type="number"></v-text-field>
                    <v-autocomplete
                        label="Site"
                        v-model="editedItem.Site"
                        :items="sites"
                        item-text="name"
                        item-value="key"
                        :rules="[v => !!v || 'Site is required']" 
                        append-outer-icon="mdi-plus"
                        @click:append-outer="siteDialog = true"
                      ></v-autocomplete>
                      <v-dialog v-model="siteDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                        <v-card>
                          <v-toolbar dark color="primary">
                            <v-btn icon dark @click="siteDialog = false">
                              <v-icon>close</v-icon>
                            </v-btn>
                            <v-toolbar-title>Sites</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-toolbar-items>
                              <v-btn dark flat @click="siteDialog = false">Save</v-btn>
                            </v-toolbar-items>
                          </v-toolbar>
                          <v-layout>
                            <sites-view v-if="siteDialog" />
                          </v-layout>
                        </v-card>
                      </v-dialog>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click.native="close">Cancel</v-btn>
            <v-btn color="blue darken-1" flat @click.native="save" :disabled="!newVehicleValid">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
</template>

<script>
import { fireStore } from '../../firebase'
export default {
  props: ['customer', 'dialog'],
  data () {
    return {
      siteDialog: false,
      newVehicleValid: false,
      gettingModels: false,
      vehicleMakes: [],
      makeSelect: null,
      vehicles: [],
      vehicleModels: {},
      modelList: [],
      sites: [],
      dialogOpened: 0,
      editedItem: {
        Customer: '',
        VehicleReg: '',
        Year: null
      },
      defaultItem: {
        Customer: '',
        VehicleReg: '',
        Year: null
      }
    }
  },
  mounted () {
    this.getVehicles()
    this.editedItem.Year = new Date().getFullYear()
    this.defaultItem.Year = this.editedItem.Year
    this.editedItem.Customer = this.customer
    this.defaultItem.Customer = this.customer
  },
  watch: {
    makeSelect: function (val) {
      this.editedItem.Make = val
      if (this.dialogOpened === 0) {
        this.editedItem.Model = null
        console.log(this.editedItem.Model)
      } else {
        this.dialogOpened = 0
      }
      if (val !== null && val !== undefined && val !== '') {
        // this.editedItem.Model = null
        this.getModels()
      }
    },
    dialog: function (val) {
      if (val) {
        this.getSites()
      }
    },
    siteDialog: function (val) {
      if (!val) {
        this.getSites()
      }
    }
  },
  methods: {
    getSites () {
      this.sites = []
      console.log('getting sites')
      fireStore.collection('Sites').where('Customer', '==', this.customer)
      .get()
      .then(snap => {
        snap.forEach(doc => {
          this.sites.push({key: doc.id, name: doc.data().Name})
        })
      })
    },
    getModels () {
      this.modelList = []
      this.gettingModels = true
      if (this.makeSelect !== undefined && this.makeSelect !== null) {
        this.modelList = this.vehicleModels[this.editedItem.Make]
      }
      this.gettingModels = false
    },
    getVehicles () {
      this.vehicles = []
      fireStore.collection('Vehicles')
      .get()
      .then(snap => {
        snap.forEach(doc => {
          let data = doc.data()
          data.id = doc.id
          this.vehicles.push(data)
          if (this.vehicleMakes.includes(data.Make) === false && data.Make !== undefined) {
            this.vehicleMakes.push(data.Make)
          }
          if (((this.vehicleModels[data.Make] && this.vehicleModels[data.Make].includes(data.Model) === false) || this.vehicleModels[data.Make] === undefined) && data.Model !== undefined && data.Make !== undefined) {
            if (this.vehicleModels[data.Make] === undefined) {
              this.vehicleModels[data.Make] = []
            }
            if (data.Model) {
              this.vehicleModels[data.Make].push(data.Model)
            }
          }
        })
      })
    },
    close () {
      this.$emit('update:dialog', false)
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.makeSelect = null
        this.sites = []
      }, 300)
    },
    save () {
      this.editedItem.VehicleReg = this.editedItem.VehicleReg.toUpperCase().replace(/\s/g, '')
      let vIndex = this.vehicles.findIndex((v) => {
        return this.editedItem.VehicleReg === v.VehicleReg ? v.VehicleReg.replace(/ /g, '').toUpperCase() : null
      })
      if (vIndex > -1) {
        return alert('That vehicle is already in the system, please try a different reg.')
      }
      this.editedItem.Customer = this.customer
      fireStore.collection('Vehicles').get()
      .then(snap => {
        let vehicleFriendlyIds = ['0']
        snap.forEach(doc => {
          const data = doc.data()
          if (data.friendlyId) {
            if (data.friendlyId.indexOf('CUBO') > -1 && data.friendlyId.indexOf('NaN') === -1) {
              let number = data.friendlyId.replace('CUBO', '')
              if (!isNaN(number)) {
                vehicleFriendlyIds.push(parseInt(number))
              }
            }
          }
        })
        vehicleFriendlyIds.sort(function (a, b) {
          return a - b
        }).reverse()
      // fireStore.collection('Vehicles').get()
      // .then(snap => {
      //   let vehicleFriendlyIds = ['0']
      //   snap.forEach(doc => {
      //     const data = doc.data()
      //     if (data.friendlyId) {
      //       if (data.friendlyId.indexOf('NIBC') > -1 && data.friendlyId.indexOf('NaN') === -1) {
      //         vehicleFriendlyIds.push(data.friendlyId.replace('NIBC', ''))
      //       }
      //     }
      //   })
      //   vehicleFriendlyIds.sort().reverse()

        const friendlyId = 'CUBO' + this.zeroFill((parseInt(vehicleFriendlyIds[0]) + 1), 5)
        console.log(friendlyId)
        this.editedItem.friendlyId = friendlyId
        this.editedItem.Added = Date.now()

        fireStore.collection('Vehicles').add(this.editedItem)
        .then((docRef) => {
          this.editedItem.id = docRef.id
          this.vehicles.push(this.editedItem)
          if (this.editedItem.Make !== undefined && this.vehicleMakes.includes(this.editedItem.Make) === false) {
            this.vehicleMakes.push(this.editedItem.Make)
          }
          if (this.vehicleModels[this.editedItem.Make]) {
            this.vehicleModels[this.editedItem.Make] = []
            if (this.vehicleModels[this.editedItem.Make].findIndex(model => { return model === this.editedItem.Model }) < 0) {
              this.vehicleModels[this.editedItem.Make].push(this.editedItem.Model)
            }
          }

          this.$emit('vehicleAdded', this.editedItem)
          this.close()
        })
      })
    },
    zeroFill (number, width) {
      width -= number.toString().length
      if (width > 0) {
        return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
      }
      return number
    }
  }
}
</script>



// WEBPACK FOOTER //
// NewVehicleDialog.vue?769a2cbf